import React, { FC } from 'react';

import { UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EUIFormItemVariant, UIFormItem } from '@aquariuxfintech/aqx-trader-react-ui/form';
import UISelectPicker from '@aquariuxfintech/aqx-trader-react-ui/select-picker';

import { EDataTestId } from '@aqx-core/common/data-test-id/types';
import { ISignUpDemoValues } from '@aqx-core/common/hooks/form/use-sign-up-demo-form';
import { DEPOSIT_OPTIONS } from '@aqx-core/common/services/sign-up-demo';

interface ISignUpDemoDepositAmountFieldProps {
  depositAmount: number;
  setValue: UseFormSetValue<ISignUpDemoValues>;
  trigger: UseFormTrigger<ISignUpDemoValues>;
  error: string | undefined;
}

const SignUpDemoDepositAmountField: FC<ISignUpDemoDepositAmountFieldProps> = ({
  setValue,
  trigger,
  depositAmount,
  error
}) => {
  const { t } = useTranslation();
  return (
    <UIFormItem variant={EUIFormItemVariant.ITEM_WITH_FIELD_LABEL} label={t('Deposit Amount')} size="large">
      <UISelectPicker<number>
        onSelect={(val) => {
          setValue('depositAmount', val);
          trigger('depositAmount');
        }}
        options={DEPOSIT_OPTIONS}
        placeholder={t('Select a deposit amount')}
        selectedValue={depositAmount}
        error={error}
        // disabled={loading}
        dataTestId={EDataTestId.SIGN_UP_COUNTRY_SELECTOR}
        size="large"
        dropDownMaxHeight={200}
      />
    </UIFormItem>
  );
};

export default SignUpDemoDepositAmountField;
